export const SEND_USER_DETAILS: string = "SEND_USER_DETAILS";
export const RESET_USER_DETAILS: string = "RESET_USER_DETAILS";
export const LOADING_OR_PENDING: string = "LOADING_OR_PENDING";
